import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import ServicesSection from '../components/ServicesSection';
import HowItWorks from '../components/HowItWorks';
import IndustriesSection from '../components/IndustriesSection';
import SocialProof from '../components/SocialProof';
import AboutSection from '../components/AboutSection';
import CTASection from '../components/CTASection';
import ContactSection from '../components/ContactSection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Rishant Technologies | AI Automation for Indian Businesses</title>
        <meta 
          name="description" 
          content="WhatsApp bots, AI customer support, and lead automation built for Indian SMBs. Setup in 5 days. Book your free automation audit." 
        />
        <meta 
          name="keywords" 
          content="AI automation, WhatsApp bots, customer support automation, lead generation, Indian businesses, SMB automation, business process automation" 
        />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Rishant Technologies | AI Automation for Indian Businesses" />
        <meta property="og:description" content="WhatsApp bots, AI customer support, and lead automation built for Indian SMBs. Setup in 5 days. Book your free automation audit." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rishant.tech" />
        <meta property="og:site_name" content="Rishant Technologies" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Rishant Technologies | AI Automation for Indian Businesses" />
        <meta name="twitter:description" content="WhatsApp bots, AI customer support, and lead automation built for Indian SMBs. Setup in 5 days. Book your free automation audit." />
        
        {/* Additional meta tags */}
        <meta name="author" content="Rishant Technologies" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://rishant.tech" />
        
        {/* TODO: Add Google Analytics tag when available */}
        {/* <script async src="https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID"></script> */}
      </Helmet>

      <main>
        <Hero />
        <ProblemSection />
        <ServicesSection />
        <HowItWorks />
        <IndustriesSection />
        <SocialProof />
        <AboutSection />
        <CTASection />
        <ContactSection />
      </main>
    </>
  );
};

export default Home;